import { ActionPayload, createAction, createReducer } from "redux-act";
import produce from "immer";

import { reducerRegistry } from "../reducerRegistry";

const reducerName = "layerTempFilter";

export type LayerTempFilterState = {
  tool: {
    active?: boolean;
    layerName?: string;
  };
  id?: string;
};

const initialState: LayerTempFilterState = {
  tool: {},
};

export const setLayerTempFilterTool = createAction<LayerTempFilterState["tool"]>(`${reducerName}/set-tool`);

export const setLayerTempFilterId = createAction<LayerTempFilterState["id"]>(`${reducerName}/set-id`);

export const reducer = createReducer({}, initialState);

reducer.on(
  setLayerTempFilterTool,
  produce((state: LayerTempFilterState, payload: ActionPayload<typeof setLayerTempFilterTool>) => {
    state.tool = payload;
  }),
);

reducer.on(
  setLayerTempFilterId,
  produce((state: LayerTempFilterState, payload: ActionPayload<typeof setLayerTempFilterId>) => {
    state.id = payload;
  }),
);

reducerRegistry.register(reducerName, reducer);
